import API from 'js/lib/api';

const feedbackAPI = API('/api/feedback.v1', {
  type: 'rest',
});

export default feedbackAPI;
